import React from 'react';
import InnerSalesOrderList from '../../sales_order/InnerSalesOrderList';

class SalesOrderTab extends React.Component {
  render() {
    const tab = this.props.activeTab;
    return (
    <div className={`tab-pane fade ${tab === 'sales_order' ? 'show active in' : ''}`}>
        <div className="row">
            <div className="col-md-12">
                <InnerSalesOrderList id={this.props.id} type={this.props.type} {...this.props}
                reload={this.props.reload} edit={this.props.edit} />;
            </div>
        </div>
    </div>
    );
  }
}
export default SalesOrderTab;